module.exports = "/images/logo_c9e1a8.png";